@if (ppAllUsers) {
  <div class="dashletActivity">
    @if (ppChange.added.length > 0) {
      <ng-container>
        <img class="dashletActivity__icon" [src]="EIconPath.BASIC_FIELD_ASSIGNEES" />
        <div class="dashletActivity__text">{{ 'added' | ppTranslate }}:</div>
      </ng-container>
      @for (assignee of ppChange.added; track assignee; let last = $last) {
        <div class="activityChange__assignees">
          @if (ppAllUsers[assignee]?.avatarPublicUrl) {
            <img
              ppImage
              [src]="ppAllUsers[assignee].avatarPublicUrl"
              class="dashboard__activity-assignees-avatar"
              />
          }
          @if (!ppAllUsers[assignee]?.avatarPublicUrl) {
            <img
              class="dashboard__activity-assignees-avatar"
              [src]="EIconPath.BASIC_FIELD_ASSIGNEES"
              />
          }
          @if (ppAllUsers[assignee]) {
            <span class="dashletActivities__item-quoted">{{ ppAllUsers[assignee].userName }}</span>
          }
          @if (!ppAllUsers[assignee]) {
            <span class="dashletActivities__item-quoted">({{ 'deleted_user' | ppTranslate }})</span>
          }
          @if (!last) {
            <span>,</span>
          }
          @if (last) {
            <span>.</span>
          }
        </div>
      }
    }
    @if (ppChange.deleted.length > 0) {
      <ng-container>
        <img class="dashletActivity__icon" [src]="EIconPath.BASIC_FIELD_ASSIGNEES" />
        <div class="dashletActivity__text">{{ 'removed' | ppTranslate }}:</div>
      </ng-container>
      @for (assignee of ppChange.deleted; track assignee; let last = $last) {
        <div
          class="activityChange__assignees"
          >
          @if (ppAllUsers[assignee]?.avatarPublicUrl) {
            <img
              ppImage
              [src]="ppAllUsers[assignee].avatarPublicUrl"
              class="dashboard__activity-assignees-avatar"
              />
          }
          @if (!ppAllUsers[assignee]?.avatarPublicUrl) {
            <img
              class="dashboard__activity-assignees-avatar"
              [src]="EIconPath.BASIC_FIELD_ASSIGNEES"
              />
          }
          @if (ppAllUsers[assignee]) {
            <span class="dashletActivities__item-quoted">{{ ppAllUsers[assignee].userName }}</span>
          }
          @if (!ppAllUsers[assignee]) {
            <span class="dashletActivities__item-quoted">({{ 'deleted_user' | ppTranslate }})</span>
          }
          @if (!last) {
            <span>,</span>
          }
          @if (last) {
            <span>.</span>
          }
        </div>
      }
    }
  </div>
}
